<template>
    <div>
        <div class="relative flex h-[250px] flex-col justify-between rounded-md bg-white p-8 shadow md:h-[350px]">
            <div>
                <h1 class="text-xl font-bold leading-tight">
                    <a :href="spotUrl" target="_blank" rel="noreferrer noopener">
                        {{ internship.title }}
                    </a>
                </h1>

                <div class="flex space-x-2">
                    <p>{{ internship.company_name }}</p>
                    <span>&middot;</span>
                    <p>{{ internship.location }}</p>
                </div>
            </div>

            <a :href="spotUrl" target="_blank" rel="noreferrer noopener">
                <img loading="lazy" :src="logoPath" alt="" class="h-24 w-full object-contain" />
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            internship: Object,
        },

        computed: {
            spotUrl() {
                return `https://placementspot.ca/stages/${this.internship.slug}`;
            },

            logoPath() {
                return `https://placementspot.ca${this.internship.company_logo_path}`;
            },
        },
    };
</script>
